export default class Dropdown {
  constructor(el) {
    this.DOM = { el: el };
    this.DOM.link = this.DOM.el.querySelector('.d-aside__item-link');
    this.DOM.dropdown = this.DOM.el.querySelector('.d-aside__dropdown');

    this.state = {
      isOpen: false,
      height: 0
    }

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.openDropdown = this.openDropdown.bind(this);

   this.init();
  }

  init() {
    if (!this.DOM.el || !this.DOM.dropdown) return;
    this.getHeight();
    this.bindEvents();
  }

  getHeight() {
    this.state.height = this.DOM.dropdown.scrollHeight;
  }

  bindEvents() {
    this.DOM.link.addEventListener('click', this.toggleDropdown);
  }

  toggleDropdown(e) {
    e.preventDefault();
    this.state.isOpen ? this.closeDropdown() : this.openDropdown();
  }

  closeDropdown() {
    this.state.isOpen = false;
    this.DOM.dropdown.style.height = '0px';
  }

  openDropdown() {
    this.state.isOpen = true;
    this.DOM.dropdown.style.height = `${this.state.height}px`;
  }
}
